import dayjs from "dayjs";
import Calc from "better-calc";
export function typeOf(obj) {
  const toString = Object.prototype.toString;
  const map = {
    "[object Boolean]": "boolean",
    "[object Number]": "number",
    "[object String]": "string",
    "[object Function]": "function",
    "[object Array]": "array",
    "[object Date]": "date",
    "[object RegExp]": "regExp",
    "[object Undefined]": "undefined",
    "[object Null]": "null",
    "[object Object]": "object"
  };
  return map[toString.call(obj)];
}
export function deepCopy(data) {
  const t = typeOf(data);
  let o;

  if (t === "array") {
    o = [];
  } else if (t === "object") {
    o = {};
  } else {
    return data;
  }

  if (t === "array") {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]));
    }
  } else if (t === "object") {
    for (let i in data) {
      o[i] = deepCopy(data[i]);
    }
  }
  return o;
}
export function debounce(func, wait) {
  let replace;
  if (typeOf(func) === "number" && typeOf(wait) === "function") {
    replace = func;
    func = wait;
    wait = replace;
  }
  let timer;
  return function(...args) {
    let context = this;
    clearTimeout(timer);
    timer = setTimeout(function() {
      func.apply(context, args);
    }, wait);
  };
}

export function fixed8(number) {
  if (isNone(number)) {
    return "-";
  }
  return number == 0 ? number : String((number - 0).toFixed(8));
}
export function fixed0(number) {
  if (isNone(number)) {
    return "-";
  }
  return number == 0 ? number : String((number - 0).toFixed(0));
}
export function throttle(func, gapTime) {
  if (gapTime == null || gapTime == undefined) {
    gapTime = 1500;
  }

  let _lastTime = null;
  return function(...args) {
    let context = this;
    let _nowTime = Number(new Date());
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      func.apply(context, args);
      _lastTime = _nowTime;
    }
  };
}
export function assignDeep(...params) {
  let class2type = {};
  let src;
  let copyIsArray;
  let copy;
  let name;
  let options;
  let clone;
  let target = params[0] || {};
  let i = 1;
  let length = params.length;
  let deep = false;
  if (typeof target === "boolean") {
    deep = target;
    target = params[i] || {};
    i++;
  }
  if (typeof target !== "object" && !isFunction(target)) {
    target = {};
  }
  if (i === length) {
    target = this;
    i--;
  }
  for (; i < length; i++) {
    if ((options = params[i]) != null) {
      for (name in options) {
        src = target[name];
        copy = options[name];
        if (target === copy) {
          continue;
        }
        if (deep && copy && (isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && Array.isArray(src) ? src : [];
          } else {
            clone = src && isPlainObject(src) ? src : {};
          }
          target[name] = assignDeep(deep, clone, copy);
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }
  function isPlainObject(obj) {
    if (!obj || obj.toString() !== "[object Object]" || obj.nodeType || obj.setInterval) {
      return false;
    }
    if (
      obj.constructor &&
      !obj.hasOwnProperty("constructor") &&
      !obj.constructor.prototype.hasOwnProperty("isPrototypeOf")
    ) {
      return false;
    }
    let key;
    for (key in obj) {
    }
    return key === undefined || obj.hasOwnProperty(key);
  }

  function type(obj) {
    if (obj == null) {
      return String(obj);
    }
    return typeof obj === "object" || typeof obj === "function"
      ? class2type[toString.call(obj)] || "object"
      : typeof obj;
  }

  function isFunction(obj) {
    return type(obj) === "function";
  }
  return target;
}
export const isFunction = item => typeOf(item) === "function"; // 判断是方法
export const isNone = field =>
  typeOf(field) === "undefined" || typeOf(field) === "null" || field === "";

export const toRegularNum = (number, long, handleNumber) => {
  if (isNone(number)) {
    return "-";
  }
  if (!handleNumber) {
    number = Calc.div(number, 100);
  }
  if (typeof long === "undefined") {
    long = 2;
  }
  if (long > 2) {
    let nump = (number - 0).toFixed(long).split(".");
    return nump[0].replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,") + "." + nump[1];
  }
  return String((number - 0).toFixed(long)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
};

export const toRegularNumFix2 = number => {
  if (isNone(number)) {
    return "-";
  }
  return String((number - 0).toFixed(2));
};
export const toDate = time => {
  let _time = dayjs(String(time)).valueOf();
  return Math.round(Calc.div(_time, 1000));
};

export const fromDate = time => {
  if (isNone(time) || Number(time) === 0) {
    return "";
  } else {
    return dayjs(Calc.mul(Number(time), 1000)).format("YYYY-MM-DD HH:mm:ss");
  }
};

export const fromDay = time => {
  if (isNone(time) || Number(time) === 0) {
    return "";
  } else {
    return dayjs(Calc.mul(Number(time), 1000)).format("YYYY-MM-DD");
  }
};
export const hashRateFormat = hashrate => {
  if (typeof hashrate != "number") {
    return hashrate;
  }
  let measurement = {
    E: Math.pow(10, 18),
    P: Math.pow(10, 15),
    T: Math.pow(10, 12),
    G: Math.pow(10, 9),
    M: Math.pow(10, 6),
    K: Math.pow(10, 3)
  };
  for (let i in measurement) {
    if (hashrate > measurement[i]) {
      let rs = hashrate / measurement[i];
      return rs.toFixed(2) + "" + i + "H/s";
    }
  }
  return hashrate + "H/s";
};
export const hashDiffFormat = hashrate => {
  if (typeof hashrate != "number") {
    return hashrate;
  }
  let measurement = {
    E: Math.pow(10, 18),
    P: Math.pow(10, 15),
    T: Math.pow(10, 12),
    G: Math.pow(10, 9),
    M: Math.pow(10, 6),
    K: Math.pow(10, 3)
  };
  for (let i in measurement) {
    if (hashrate > measurement[i]) {
      let rs = hashrate / measurement[i];
      return rs.toFixed(2) + "" + i;
    }
  }
  return hashrate;
};

export const typeStatus = time => {
  switch (time) {
    case 1:
      return "代收";
      break;
    case 2:
      return "提现";
      break;
    case 3:
      return "代付";
      break;
    default:
      return "未知";
      break;
  }
};

// 根据字符创生成指定的嵌套对象
export const createAssociativeArray = (string, object, label) => {
  let parts = string.split(label || "|");
  let last = parts[parts.length - 1];
  let tree = {};
  let node = parts.slice(0, -1).reduce(function(memo, current) {
    return (memo[current] = {});
  }, tree);
  node[last] = object;
  return tree;
};

const isObject = obj => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};

// 获取嵌套对象属性的值   data: obj    target:string
export const getValue = (data, target) => {
  for (const key of Object.keys(data)) {
    if (key === target) {
      return data[key];
    }
    if (isObject(data[key])) {
      const result = getValue(data[key], target);
      if (result) {
        return result;
      }
    }
  }
};

export const toPrice = row => {
  return Math.round(row / 100);
};
